import { Fragment } from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  price: { fontSize: '12px' },
});

type PriceSectionProps = {
  title: string;
  prices: { name: string; value: number | unknown }[];
};

const Prices = ({ title, prices }: PriceSectionProps) => {
  const classes = useStyles();

  return (
    <>
      <h5>{title}</h5>
      <span className={classes.price}>
        {prices.map(({ name, value }, index) => (
          <Fragment key={name}>
            {name}: {typeof value === 'number' ? value.toFixed(2) : '0.00'}
            {index < prices.length - 1 && <br />}
          </Fragment>
        ))}
      </span>
    </>
  );
};

export default Prices;
